const getCustomLabelValue = (value, answerChoices = []) => {
  let foundIndex = answerChoices?.findIndex(
    (answer) => answer.choice === value
  );
  const code = "A".charCodeAt(0);
  return String.fromCharCode(code + foundIndex);
};

export default getCustomLabelValue;
